import React, { useState, useEffect, useRef } from "react";
import "./tableStyle.css";
import { reportsApi } from "../../Services/Services";
// import { Input, Form, Button } from 'antd';
import { Col, Input, Button, Radio, Form, Select } from "antd";
import { useReactToPrint } from "react-to-print";
import { FaFileExcel, FaPrint } from "react-icons/fa";
import * as XLSX from "xlsx"; // Import xlsx library
import { Link } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";

const { Option } = Select;

export default function BillRegister() {
  const [billList, setBillList] = useState([]);
  const [hasMore, setHasMore] = useState(true);
  const [offset, setOffset] = useState(0);
  const limit = 50; // ek baar me 50 records load honge

  useEffect(() => {
    fetchMoreData(); // initial fetch
  }, []);

  const fetchMoreData = async () => {
    const response = await reportsApi({
      report_name: "do_bill_register",
      com_name: localStorage.getItem("com_name"),
      limit,
      offset,
    });

    if (response && response.results) {
      // pagination response ke liye
      setBillList((prev) => [...prev, ...response.results]);
      setOffset((prev) => prev + limit);

      if (!response.next) {
        // agar aur data nahi hai
        setHasMore(false);
      }
    }
  };

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });
  const handleExportToExcel = () => {
    const workbook = XLSX.utils.book_new();
    const wsData = billList.map((e, index) => [
      index + 1,
      e.client_name,
      e.do_no,
      e.bill_no,
      e.pay_amount,
      e.date,
    ]);

    const worksheet = XLSX.utils.aoa_to_sheet([
      ["Sr. No", "Party Name", "Do No", "Bill No", "Pay Amount", "Date"],
      ...wsData,
    ]);
    XLSX.utils.book_append_sheet(workbook, worksheet, "DeliveryOrder");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, "Bill List.xlsx");
  };
  const formateDate = (date) => {
    const [year, month, day] = date.split("-");
    const formattedDate = `${day}-${month}-${year}`;
    return formattedDate;
  };

  const getYearsArray = (startYear, endYear) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push(year);
    }
    return years;
  };
  const currentYear = new Date().getFullYear();
  const years = getYearsArray(2023, currentYear);

  const [selectedYear, setSelectedYear] = useState(currentYear);

  return (
    <div>
      <Form layout="vertical">
        <div className=" grid grid-cols-1 sm:grid sm:grid-cols-4 sm:gap-2 m-auto px-5 sm:w-[70%]  md:w-[100%] ">
          <Col>
            <label>
              <b>Select Year</b>
            </label>

            <Select
              value={selectedYear} // <-- Set current year as selected
              onChange={(value) => setSelectedYear(value)} // <-- Allow user to change
              showSearch
              style={{ width: "95%", marginRight: "2%", marginTop: "12px" }}
              placeholder="Select Year"
            >
              {years.map((year) => (
                <Option value={year}>{year}</Option>
              ))}
            </Select>
          </Col>

          <Form.Item
            name="bill_no"
            label={<b>Search Bill Number</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Input placeholder="Search Bill Number" />
          </Form.Item>

          <Form.Item
            name="do_no"
            label={<b>Search DO No</b>}
            style={{ padding: "2px", margin: "2px" }}
          >
            <Input placeholder="Search Bill No" />
          </Form.Item>
          <Form.Item>
            <br></br>

            <Button
              onClick={handlePrint}
              style={{ backgroundColor: "black", color: "white", top: "11px" }}
            >
              <FaPrint />
            </Button>
            <Button
              onClick={handleExportToExcel}
              style={{
                backgroundColor: "green",
                color: "white",
                marginLeft: "10px",
                top: "11px",
              }}
            >
              <FaFileExcel />
            </Button>
          </Form.Item>
        </div>
      </Form>
      <div
        className="table-wrapper-3"
        ref={componentRef}
        style={{ maxHeight: "500px", overflowX: "auto", overflowY: "auto" }}
      >
        <InfiniteScroll
          dataLength={billList.length}
          next={fetchMoreData}
          hasMore={hasMore}
          loader={
            <div style={{ textAlign: "center", margin: "10px" }}>
              Loading...
            </div>
          }
          scrollableTarget="scrollableDiv"
        ></InfiniteScroll>
        <table id="my-table" className="w-full">
          <thead className="bg-[#151B54] w-full text-white">
            <tr>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Sr. No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Id
              </th>

              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                Party Name
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Do No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                Bill No
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                {" "}
                Amount
              </th>
              <th className="lg:text-[12px] text-[0.41rem] p-0 sm:px-2 px-1 lg:p-1 sm:text-base">
                {" "}
                Bill Date
              </th>
            </tr>
          </thead>
          <tbody>
            {billList.map((e, index) => (
              <tr
                key={e.index}
                style={{ backgroundColor: e.rem_qty === 0 ? "#b8ebb8" : "" }}
              >
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {index + 1}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.bill_id}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.client_name}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  <Link to={`/do-view/${e.do_id}`}>
                    <u style={{ fontWeight: "600", color: "blue" }}>
                      {e.do_no}
                    </u>
                  </Link>
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.bill_no}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {e.pay_amount}
                </td>
                <td className="lg:text-[12px] text-[0.41rem] p-0 sm:px-3 px-1 lg:p-1 sm:text-base">
                  {formateDate(e.date)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
